import { render, staticRenderFns } from "./TheGrottaHouseBook.vue?vue&type=template&id=12b52642&scoped=true"
import script from "./TheGrottaHouseBook.vue?vue&type=script&lang=js"
export * from "./TheGrottaHouseBook.vue?vue&type=script&lang=js"
import style0 from "./TheGrottaHouseBook.vue?vue&type=style&index=0&id=12b52642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b52642",
  null
  
)

export default component.exports